import React from "react";
import { LOCALE_DETAILS } from "../localization/locales";
import { setLocale, translate, useLocale } from "../localization";
import "./LanguagePicker.scss";

export default function LanguagePicker() {
  const locale = useLocale();
  return (
    <label className="language-picker">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="9" />
        <ellipse cx="12" cy="12" rx="4" ry="9" />
        <path d="M3 12h18M5 6h14M5 18h14" />
      </svg>
      <select aria-label={translate("Language")} value={locale} onChange={(event) => setLocale(event.target.value)}>
        {LOCALE_DETAILS.map((language) => (
          <option key={language.locale} value={language.locale} lang={language.locale}>
            {language.nativeName}
          </option>
        ))}
      </select>
    </label>
  );
}
